function DateModal(automaticExport) {
  if (!this instanceof DateModal) return new DateModal();

  const that = this;
  this.selectedWeekdays = [];

  /**
   * @type Element
   */
  this.node = automaticExport.node;
  this.automaticExport = automaticExport;

  this.loadJson = function (json) {
    this.json = json;

    const xhr = new XMLHttpRequest();
    const that = this;
    xhr.open("GET", "content/date-modal.html", true);
    xhr.onreadystatechange = function () {
      if (this.readyState !== 4) return;
      if (this.status !== 200) return;

      const dateModal = that.node.querySelector(".date-modal");
      dateModal.insertAdjacentHTML("beforeend", this.responseText);

      if (json.data.dateConfig) {
        if (json.data.dateConfig.weekdays)
          that.selectedWeekdays = json.data.dateConfig.weekdays.filter(
            (row) => row.active === true
          );
        that.selectedWeekdays = that.selectedWeekdays.map((row) => row.weekday);

        if (json.data.dateConfig.interval) {
          const intervalSelect = that.node.querySelector(
            ".date-modal .interval-select"
          );
          let options = Array.from(intervalSelect.options);
          options.map((option, index) => {
            if (option.value === json.data.dateConfig.interval) {
              intervalSelect.selectedIndex = index;
            }
          });
        }
      }

      that.renderWeekdays();
      that.initHandlers(json);
    };
    xhr.send();
  };

  this.renderWeekdays = function () {
    const weekdayContainer = this.node.querySelector(".weekday-container");

    const weekdays = [
      {
        weekday: "monday",
        short: "Mo.",
      },
      {
        weekday: "tuesday",
        short: "Di.",
      },
      {
        weekday: "wednesday",
        short: "Mi.",
      },
      {
        weekday: "thursday",
        short: "Do.",
      },
      {
        weekday: "friday",
        short: "Fr.",
      },
      {
        weekday: "saturday",
        short: "Sa.",
      },
      {
        weekday: "sunday",
        short: "So.",
      },
    ];

    weekdays.map((row) => {
      const weekdayButton = document.createElement("button");
      weekdayButton.classList.add(
        "mdl-button",
        "mdl-js-button",
        "mdl-js-ripple-effect"
      );
      weekdayButton.innerText = row.short;
      weekdayContainer.appendChild(weekdayButton);

      if (this.selectedWeekdays.includes(row.weekday)) {
        weekdayButton.classList.add("active");
      }

      weekdayButton.addEventListener("click", (event) => {
        event.target.classList.toggle("active");

        if (!this.selectedWeekdays.includes(row.weekday)) {
          this.selectedWeekdays.push(row.weekday);
        } else {
          this.selectedWeekdays = this.selectedWeekdays.filter(
            (w) => w !== row.weekday
          );
        }
      });
    });
  };

  this.initHandlers = function () {
    const dateButton = this.node.querySelector(".date-button");

    dateButton.addEventListener("click", () => {
      this.toggleModal();
    });

    const closeButton = this.node.querySelector(".date-modal .close-button");
    closeButton.addEventListener("click", () => {
      this.toggleModal();
    });

    window.addEventListener("click", (event) => {
      this.windowOnClick(event);
    });

    const cancelButton = this.node.querySelector(".date-modal .cancel-button");
    cancelButton.addEventListener("click", () => {
      this.toggleModal();
    });

    const saveButton = this.node.querySelector(".date-modal .save-button");
    saveButton.addEventListener("click", () => {
      this.saveConfig();
    });
  };

  this.toggleModal = function () {
    const modal = this.node.querySelector(".date-modal");
    modal.classList.toggle("show-modal");
  };

  this.windowOnClick = function (event) {
    const modal = this.node.querySelector(".date-modal");
    if (event.target === modal) {
      this.toggleModal();
    }
  };

  this.saveConfig = function () {
    const intervalSelect = this.node.querySelector(
      ".date-modal .interval-select"
    );
    const weekdayConfig = {
      interval: intervalSelect.options[intervalSelect.selectedIndex].value,
      weekdays: this.selectedWeekdays,
    };

    const that = this;
    const xhr = Network.openXHR(
      "POST",
      `${API_PATH}automaticExport/${this.json.data.id}/dateConfig`
    );
    xhr.onerror = () => {
      snackbar.show({
        message:
          "Beim Speichern der Datums-Einstellungen ist ein unbekannter Fehler aufgetreten.",
      });
    };
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        that.automaticExport.setJSONData(JSON.parse(this.responseText));
        that.toggleModal();
        snackbar.show({
          message: "Die Datums-Einstellungen wurden erfolgreich gespeichert.",
        });
      }
    };

    xhr.send(JSON.stringify(weekdayConfig));
  };
}
